import template from './ko-field-input-file.html';

class FileInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.uploaded_files = ko.observableArray();
		this.files_location = ko.observable('/DAV/FileFields');
		this.loading = ko.observable(false);
		this.readonly = ko.observable(params.readonly);

		if (params.ui_fields)
		{
			if (params.ui_fields.upload_url !== '')
				this.files_location(params.ui_fields.upload_url);
		}

		this.load_existing_files();
	}

	async on_file_select(_data, event)
	{
		let file_input = document.getElementById('ps-file-upload-input-' + this.name());
		let files = file_input.files;
		let file_name;

		if (files.length > 0)
		{
			for (let file of files)
			{
				let response = await fetch(`${this.files_location()}/${file.name}`, {
					method: 'PUT',
					headers: { 'content-type': file.type },
					body: file
				});

				file_name = file.name;

				if (!response.ok)
					Grape.alerts.alert({ type: 'warning', title: 'Warning', message: `"File upload failed for", ${file.name}` });
			}

			this.uploaded_files.push({
				name: file_name,
				fullPath: `${this.files_location()}/${file_name}`,
			});

			this.$input([...this.uploaded_files()]);
		} 
		else
			Grape.alerts.alert({ type: 'info', title: 'No File', message: 'No files selected!' });
	}

	async delete_file(file) 
	{
		let response = await Grape.alerts.confirm({
			message: 'Are you sure you want to delete this file? In order to remove the file from this contact, please save the contact after selecting "Yes"',
			title: 'Delete File',
			type: 'danger'
		})

		if (response)
		{
			let response = await fetch(`${this.files_location()}/${file.name}`, {
				method: 'DELETE',
				headers: { 'content-type': 'application/json' },
				body: []
			});

			if (response.ok)
			{
				// Remove file by name to ensure proper removal
				this.uploaded_files.remove(item => item.name === file.name);
				this.$input([...this.uploaded_files()]);
			}
			else
				console.error('File deletion failed', response.status);
		}
	}

	async open_file(file)
	{
		try {
			if (file.fullPath)
				window.open(file.fullPath, '_blank');
			else
			{
				const fileUrl = `${this.files_location()}/${file.name}`;
				window.open(fileUrl, '_blank');
			}
		} catch (error) {
			console.error('Error opening file:', error);
			Grape.alerts.alert({ type: 'error', title: 'Error', message: 'Unable to open file.' });
		}
	}

	load_existing_files()
	{
		let input = this.$input();
		let files = [];

		if (!this.$input())
			return;

		if (typeof input === 'string')
		{
			try {
				files = JSON.parse(input);

				if (!Array.isArray(files))
				{
					console.error('Invalid data after parsing JSON, expected an array of file objects:', files);
					return;
				}

			} catch (error) {
				console.error('Error parsing JSON string:', error);
				return;
			}
		}
		else if (Array.isArray(input))
			files = input;
		else
		{
			console.error('Invalid $input data, expected a string or an array:', input);
			return;
		}

		files.forEach(file => {
			if (file && typeof file.name === 'string' && typeof file.fullPath === 'string')
			{
				this.uploaded_files.push({
					name: file.name,
					fullPath: file.fullPath,
				});
			}
			else
				console.error('Invalid file object:', file);
		});
	}
}


export default {
	name: 'ko-field-input-file',
	viewModel: FileInputComponentVM,
	module_type: 'ko',
	template: template
}
